export class StimulationPopup {
    constructor() {
        this.popup = document.getElementById('stimulation-popup');
        this.closeButton = document.getElementById('close-stimulation-popup');
        this.link = document.querySelector('.stimulation-popup__link');
        this.isVisible = false;
        this.autoHideTimer = null;
        
        this.init();
    }
    
    init() {
        if (!this.popup) return;
        
        // Показываем попап через 2 секунды после загрузки страницы
        setTimeout(() => {
            this.show();
        }, 2000);
        
        // Обработчик закрытия по клику на крестик
        if (this.closeButton) {
            this.closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.hide();
            });
        }
        
        // Обработчик клика по ссылке
        if (this.link) {
            this.link.addEventListener('click', (e) => {
                // Не закрываем попап при клике по ссылке, только переходим
                // this.hide();
            });
        }
        
        // Обработчик клика вне попапа
        document.addEventListener('click', (e) => {
            if (this.isVisible && !this.popup.contains(e.target)) {
                this.hide();
            }
        });
    }
    
    show() {
        if (this.isVisible || !this.popup) return;
        
        this.popup.style.display = 'block';
        this.popup.classList.add('show');
        this.isVisible = true;
        
        // Автоматическое скрытие через 15 секунд
        this.autoHideTimer = setTimeout(() => {
            this.hide();
        }, 15000);
    }
    
    hide() {
        if (!this.isVisible || !this.popup) return;
        
        this.popup.classList.remove('show');
        this.popup.classList.add('hide');
        
        // Очищаем таймер
        if (this.autoHideTimer) {
            clearTimeout(this.autoHideTimer);
            this.autoHideTimer = null;
        }
        
        // Полностью скрываем после анимации
        setTimeout(() => {
            this.popup.style.display = 'none';
            this.popup.classList.remove('hide');
            this.isVisible = false;
        }, 300);
    }
    
    // Метод для принудительного показа (если нужно)
    forceShow() {
        this.show();
    }
    
    // Метод для принудительного скрытия (если нужно)
    forceHide() {
        this.hide();
    }
}
